import React from 'react';

export default class SectionTitle extends React.Component {
    render() {
        return <h2>{this.props.children}</h2>
    }
}


// WEBPACK FOOTER //
// ./src/components/Presentation/SectionTitle.js